import { useCallback, useMemo } from 'react'
import { Bot, KeyRound } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn, RowAction } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { useToast } from '@/providers/UiProviders'
import { fetchBotTokens, revokeBotToken, DEV_STR as S, type BotTokenRow } from './devApi'

/**
 * A13.07 — Мониторинг токенов ботов + A13.09 forced revoke. Dormant until
 * `/admin/developers/bot-tokens` ships. Placeholder permission USERS_VIEW.
 */
export function BotTokensScreen() {
  const { toast } = useToast()

  const columns = useMemo<AdminColumn<BotTokenRow>[]>(
    () => [
      { key: 'bot_username', header: S.bot, type: 'text' },
      { key: 'owner', header: S.owner, type: 'text' },
      { key: 'last_used', header: S.lastUsed, type: 'text' },
      { key: 'requests', header: S.requests, type: 'number' },
    ],
    [],
  )

  const rowActions = useMemo<RowAction<BotTokenRow>[]>(
    () => [
      {
        id: 'revoke',
        label: S.revoke,
        icon: <KeyRound size={14} />,
        danger: true,
        visible: (r) => !r.revoked,
        onSelect: async (r) => {
          try {
            await revokeBotToken(r.id)
            toast(S.revoked, { tone: 'success' })
          } catch {
            toast(S.failed, { tone: 'error' })
          }
        },
      },
    ],
    [toast],
  )

  const fetcher = useCallback(fetchBotTokens, [])
  return (
    <>
      <PageHeader title={S.botTokens} screenId="A13.07" />
      <DataTable<BotTokenRow>
        screenId="A13.07"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        rowActions={rowActions}
        exportable
        emptyState={{ icon: <Bot size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
